import request from '@/utils/request'

let MyTeamApi = {
  
    userlist(data) {
        return request._post('/shop/myteam.index/index', data);
    },
   
}
export default MyTeamApi;



// WEBPACK FOOTER //
// ./src/api/myteam.js